import { HTTPMethod } from '../../types/enums';
import BaseAdapter from './baseAdapter';
import type { OptionType } from '../../types/forms.type';
import { AdapterInterface } from '../../types/global';
import { BaseComponent } from '../../api-models';

export default class GetDebtMetricDropdownOptions extends BaseAdapter<BaseComponent[]>implements AdapterInterface {
  rawResponse: BaseComponent[];

  modifiedRequest: string;

  async adaptResponse(request: string): Promise<OptionType[]> {
    await this.fetchApiResponse(`/api/debt/map-dropdown-options?debt_type=${request}`, HTTPMethod.Get);
    return this.rawResponse.map((option) => ({
      label: option.display_name,
      value: option.id,
    }));
  }
}
